/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tier2Model } from './Tier2Model';
import {
    Tier2ModelFromJSON,
    Tier2ModelFromJSONTyped,
    Tier2ModelToJSON,
    Tier2ModelToJSONTyped,
} from './Tier2Model';

/**
 * 
 * @export
 * @interface Tier2ServiceGetResponse
 */
export interface Tier2ServiceGetResponse {
    /**
     * 
     * @type {Array<Tier2Model>}
     * @memberof Tier2ServiceGetResponse
     */
    tier2s?: Array<Tier2Model> | null;
}

/**
 * Check if a given object implements the Tier2ServiceGetResponse interface.
 */
export function instanceOfTier2ServiceGetResponse(value: object): value is Tier2ServiceGetResponse {
    return true;
}

export function Tier2ServiceGetResponseFromJSON(json: any): Tier2ServiceGetResponse {
    return Tier2ServiceGetResponseFromJSONTyped(json, false);
}

export function Tier2ServiceGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tier2ServiceGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tier2s': json['tier2s'] == null ? undefined : ((json['tier2s'] as Array<any>).map(Tier2ModelFromJSON)),
    };
}

export function Tier2ServiceGetResponseToJSON(json: any): Tier2ServiceGetResponse {
    return Tier2ServiceGetResponseToJSONTyped(json, false);
}

export function Tier2ServiceGetResponseToJSONTyped(value?: Tier2ServiceGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tier2s': value['tier2s'] == null ? undefined : ((value['tier2s'] as Array<any>).map(Tier2ModelToJSON)),
    };
}

